import LoginPage from "./LoginPage";

export default function RegisterPage() {
  return <LoginPage initialMode="create" />;
}
